import { __decorate } from "tslib";
import { AsnProp } from "@peculiar/asn1-schema";
import { AuthorityInfoAccessSyntax, Name } from "@peculiar/asn1-x509";
export class ServiceLocator {
    constructor(params = {}) {
        this.issuer = new Name();
        this.locator = new AuthorityInfoAccessSyntax();
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: Name })
], ServiceLocator.prototype, "issuer", void 0);
__decorate([
    AsnProp({ type: AuthorityInfoAccessSyntax })
], ServiceLocator.prototype, "locator", void 0);
